var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentNewImportable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0c-.982 0-3 2.018-3 3v16c0 1 1 2 2 2h12c.982 0 1-1.018 1-2V5l-4-5z",
    fill: "#95a5a6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0c-.982 0-2 1.018-2 2v16c0 .982 1.018 2 2 2h12c.982 0 2-1.018 2-2V5l-5-5z",
    fill: "#bdc3c7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5l-5-5v3c0 .982 1.03 1.845 2 2z",
    fill: "#95a5a6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.5 0 0 .5 16.225 -497.681)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.55,
    cy: 1034.362,
    r: 9,
    fill: "#27ae60"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.55,
    cy: 1032.362,
    r: 9,
    fill: "#2ecc71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.55 1035.362h4v4h2v-4h4v-2h-4v-4h-2v4h-4z",
    fill: "#27ae60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.55 1033.362h4v4h2v-4h4v-2h-4v-4h-2v4h-4z",
    fill: "#ecf0f1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentNewImportable);
export default __webpack_public_path__ + "static/media/document-new-importable.138e383a97e1dcf101ffa0f27b56fc8f.svg";
export { ForwardRef as ReactComponent };